
const apiConfig = {
    //Local
    //apiUrl: 'https://localhost:7295/api/',
    //Live

    //DEV

    //test

    // Live
    apiUrl: 'https://madavana-api-new.solegaze.com/api/',

    apiKey: 'Lieda1002',
};

export default apiConfig;

